module.exports = __webpack_public_path__ + "static/aa9093e798cd0469fe081503956683ce981a3e0e4194431ce20f2fef4bf95515-4380985f211f9a9795449de5eb456f4d.png";